import type { Dayjs, ManipulateType, OpUnitType } from 'dayjs';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function overlaps(
  startMomentA: Dayjs,
  endMomentA: Dayjs,
  startMomentB: Dayjs,
  endMomentB: Dayjs,
) {
  return (
    startMomentA.isSameOrBefore(endMomentB, 'day') &&
    startMomentB.isSameOrBefore(endMomentA, 'day')
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function getPeriodsInRange(
  startMoment: Dayjs,
  endMoment: Dayjs,
  period: ManipulateType,
) {
  if (!startMoment || !endMoment) {
    return [];
  }

  const chosenPeriod = period || 'day';
  let index = startMoment;
  const periods = [];
  while (index.isSameOrBefore(endMoment, chosenPeriod)) {
    periods.push(index);
    index = index.add(1, chosenPeriod);
  }

  return periods;
}

// Checks if the given start and end date match the given period (e.g. 'month', 'quarter', 'year')
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isFixedPeriod(
  startDate: Dayjs,
  endDate: Dayjs,
  periodName: OpUnitType,
) {
  const startOfPeriod = startDate.startOf(periodName);
  const endOfPeriod = startDate.endOf(periodName);
  return (
    startDate.isSame(startOfPeriod, 'day') && endDate.isSame(endOfPeriod, 'day')
  );
}

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
export function isFixedPeriodVsReference(
  startDate: Dayjs,
  endDate: Dayjs,
  referencePeriod: Dayjs,
  periodName: OpUnitType,
) {
  const startOfPeriod = referencePeriod.startOf(periodName);
  const endOfPeriod = referencePeriod.endOf(periodName);
  return (
    startDate.isSame(startOfPeriod, 'day') && endDate.isSame(endOfPeriod, 'day')
  );
}
